<template>
  <div class="clickable" @click="onGroupAdd">
    <i class="mdi mdi-plus-circle-outline"></i>
    Insertar grupo
  </div>
</template>

<script>
export default {
  name: 'GroupAddBtn',
  props: {
    nodes: Array
  },
  methods: {
    onGroupAdd () {
      this.$emit('group-add', { nodes: this.nodes })
    }
  }
}
</script>
